//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from 'vuex'
import { questionType } from '@/server/constants'
import LoadingOverlay from '@/components/LoadingOverlay'
import PropertyAnswerSyncBackModal from '@/components/properties/PropertyAnswerSyncBackModal'
import { isEmpty } from 'lodash-es'
import { validLoisValue } from '@/server/commonwithclient'

export default {
  name: 'QuestionAnswerForm',
  components: {
    LoadingOverlay,
    PropertyAnswerSyncBackModal
  },
  props: {
    projectInReview: {
      type: Boolean,
      default: false,
      required: true
    },
    question: {
      type: Object,
      default: () => {},
      required: true
    }
  },
  data() {
    return {
      answer: {
        choice: '',
        number: null,
        text: ''
      },
      recallAnswerCount: null,
      recallAnswerStatus: false,
      saving: false,
      syncBackConflicts: []
    }
  },
  computed: {
    ...mapGetters({
      answers: 'answers/getAnswers',
      getAnswerByQuestion: 'answers/getAnswerByQuestion',
      getLastAnswerByQuestion: 'answers/getLastAnswerByQuestion',
      getFormattedAnswerByQuestion: 'answers/getFormattedAnswerByQuestion',
      getIsQuestionAnswered: 'answers/getIsQuestionAnswered',
      isParticipant: 'user/isParticipant',
      isProjectOwner: 'user/isProjectOwner',
      isActingAsReviewer: 'user/isActingAsReviewer',
      participant: 'participants/getProjectParticipant',
      propertyIsSubmitted: 'properties/getPropertyIsSubmitted',
      activeProject: 'projects/getActiveProject'
    }),
    projectName() {
      return this.activeProject ? this.activeProject.name : ''
    },
    syncBackModalId() {
      return `property-answer-syncback-modal-${this.question._id}`
    },
    disableSaveBtn() {
      const { type } = this.question
      const disableText = type === questionType.text && this.answer.text === ''
      const disableNumber = type === questionType.number && Number.isNaN(this.answer.number)
      const disableChoice = type === questionType.choice && this.answer.choice === ''
      return this.saving || disableText || disableNumber || disableChoice
    },
    displayClearAnswer() {
      // do not allow answer to be deleted if question is required and property is already submitted
      if (this.question.required && this.propertyIsSubmitted && this.questionIsAnswered) {
        return false
      }
      // do not allow answer to be deleted if there is a valid LOIS answer provided, user can only update
      // this ensures required categories indicators are correct
      if (this.questionIsAnsweredByLOIS) {
        return false
      }
      return this.questionIsAnswered
    },
    displayRecallAnswer() {
      return this.isParticipant && !this.questionIsAnswered && !this.propertyIsSubmitted && !this.question.requirement
    },
    displayRecallAnswerNotice() {
      return this.isParticipant && !this.questionIsAnswered && !this.propertyIsSubmitted && !this.question.requirement && this.recallAnswerStatus
    },
    formattedAnswer() {
      const answer = this.getFormattedAnswerByQuestion(null, this.questionAnswerLatest)
      return answer === null ? 'No Answer On File' : answer
    },
    questionAnswer() {
      return this.getAnswerByQuestion(this.question._id)
    },
    questionAnswerLatest() {
      return this.getLastAnswerByQuestion(this.question._id)
    },
    questionIsAnswered() {
      return this.getIsQuestionAnswered(this.question._id)
    },
    questionAnswerValueFromLois() {
      const answer = this.questionAnswer.display || this.questionAnswer?.loisValue
      return Array.isArray(answer) ? answer.join(',') : answer
    },
    questionAnswerValueFromLoisDisplay() {
      const lValue = this.questionAnswerValueFromLois
      return validLoisValue(lValue) ? lValue : 'Not Answered'
    },
    questionIsAnsweredByLOIS() {
      const answer = validLoisValue(this.questionAnswer?.loisValue)
      return answer !== null
    },
    questionChoices() {
      return this.question?.choices
    }
  },
  watch: {
    formattedAnswer(newVal) {
      if (newVal) {
        this.prefillAnswer()
      } else {
        this.answer.text = ''
        this.answer.choice = ''
        this.answer.number = null
      }
    },
    questionIsAnswered(newVal) {
      if (newVal) {
        this.prefillAnswer()
      } else {
        this.answer.text = ''
        this.answer.choice = ''
        this.answer.number = null
      }
    }
  },
  mounted() {
    if (this.questionIsAnswered) {
      this.prefillAnswer()
    }
  },
  methods: {
    ...mapActions({
      addAnswer: 'answers/addAnswer',
      addAnswerUpdate: 'answers/addAnswerUpdate',
      deleteAnswer: 'answers/deleteAnswer',
      fetchAnswers: 'answers/fetchAnswersForProperty',
      updateAnswer: 'answers/updateAnswer',
      recallAnswer: 'answers/recallAnswer',
      participantEditedQuestionDuringProjectReview: 'events/participantEditedQuestionDuringProjectReview',
      syncPropertyAnswersWithLois: 'properties/syncPropertyAnswersWithLois',
      detectSyncBackCandidates: 'properties/detectSyncBackCandidates',
      applySyncBack: 'properties/applySyncBack'
    }),
    async answerQuestion() {
      /*
        Property new or working status:
         - owner or participant can add, edit and delete answers with addAnswer, updateAnswer, deleteAnswer
         - audit record is not created while property still in 'new' and 'working' status
        Property submitted status:
         - no answer provided, call addAnswer
         - changing or deleting existing answer, call addAnswerUpdate which records an audit record
         - deleting existing answer pass empty values for the answer so it shows the deletion in audit log
      */
      this.saving = true
      const { projectid, propertyid } = this.$route.params
      let answer = ''
      if (this.question.type === questionType.text) {
        answer = this.answer.text?.trim() || ''
      } else if (this.question.type === questionType.number) {
        answer = this.answer.number
      } else {
        answer = this.answer.choice
      }
      if (!this.propertyIsSubmitted) {
        if (isEmpty(this.questionAnswer)) {
          await this.addAnswer({ projectId: projectid, propertyId: propertyid, questionId: this.question._id, answerData: { value: answer } })
        } else {
          await this.updateAnswer({ projectId: projectid, propertyId: propertyid, answer: { ...this.questionAnswer, value: answer } })
        }
      } else if (this.propertyIsSubmitted && isEmpty(this.questionAnswer)) {
        await this.addAnswer({ projectId: projectid, propertyId: propertyid, questionId: this.question._id, answerData: { value: answer } })
      } else {
        await this.addAnswerUpdate({ projectId: projectid, propertyId: propertyid, answer: { ...this.questionAnswer, value: answer } })
      }
      if (this.projectInReview) {
        await this.notifyOwnerOfAnswerChange()
      }
      this.saving = false
      // The submit-time sync-back only runs on submission. For edits made after
      // the property is already submitted, offer to push this single answer back
      // to the linked LOIS field here.
      await this.maybeSyncBackToLois()
      if (this.question.required) {
        this.$root.$emit('refresh-required-categories')
      }
      if (this.isParticipant) {
        this.$root.$emit('bv::toggle::collapse', this.question._id)
      }
    },
    // Post-submission per-answer sync-back. Only for LOIS-linked questions on an
    // already-submitted property; the server re-checks editable/manual guards.
    // An empty LOIS field is filled silently; a genuine conflict pops the modal.
    async maybeSyncBackToLois() {
      if (!this.question.loisDataField || !this.propertyIsSubmitted) {
        return
      }
      const { projectid: projectId, propertyid: propertyId } = this.$route.params
      const result = await this.detectSyncBackCandidates({
        projectId,
        propertyId,
        questionId: this.question._id
      })
      if (!result || !result.editable || !result.isManual) {
        return
      }
      const { conflicts = [], autoUpdates = [] } = result
      if (conflicts.length) {
        this.syncBackConflicts = conflicts
        this.$bvModal.show(this.syncBackModalId)
      } else if (autoUpdates.length) {
        await this.applySyncBack({ projectId, propertyId, questionId: this.question._id, questionIds: [] })
        await this.fetchAnswers({ projectId, propertyId })
      }
    },
    async onSyncBackResolve({ action }) {
      this.$bvModal.hide(this.syncBackModalId)
      const questionIds = this.syncBackConflicts.map(c => c.questionId)
      this.syncBackConflicts = []
      if (action !== 'update') {
        return
      }
      const { projectid: projectId, propertyid: propertyId } = this.$route.params
      this.saving = true
      await this.applySyncBack({ projectId, propertyId, questionId: this.question._id, questionIds })
      await this.fetchAnswers({ projectId, propertyId })
      this.saving = false
    },
    formattedChoice(choice) {
      return choice
    },
    async notifyOwnerOfAnswerChange() {
      const { propertyid } = this.$route.params
      const params = {
        participantId: this.participant._id,
        propertyId: propertyid,
        questionId: this.question._id
      }
      await this.participantEditedQuestionDuringProjectReview(params)
    },
    prefillAnswer() {
      if (this.questionIsAnswered) {
        if (this.question.type === questionType.text) {
          // For text answers, use the raw value without formatting to preserve user input
          this.answer.text = this.questionAnswer.value || this.questionAnswer.display || this.questionAnswer.loisValue
          this.answer.number = null
          this.answer.choice = ''
        } else if (this.question.type === questionType.number) {
          this.answer.number = parseFloat(this.formattedAnswer)
          this.answer.text = ''
          this.answer.choice = ''
        } else {
          this.answer.choice = this.formattedAnswer
          this.answer.text = ''
          this.answer.number = null
        }
      }
    },
    async recallQuestionAnswer() {
      this.saving = true
      const { projectid: projectId, propertyid: propertyId } = this.$route.params
      const { tag: questionTag, _id: questionId } = this.question
      const answersRecalled = await this.recallAnswer({ projectId, propertyId, questionTag, questionId })
      this.recallAnswerCount = answersRecalled
      this.recallAnswerStatus = true
      if (!answersRecalled) {
        this.saving = false
        setTimeout(() => {
          this.recallAnswerStatus = false
        }, 5000)
        return
      } else {
        await this.fetchAnswers({ projectId, propertyId })
        if (this.question.required) {
          this.$root.$emit('refresh-required-categories')
        }
        this.saving = false
        setTimeout(() => {
          this.recallAnswerStatus = false
        }, 5000)
      }
      this.recallAnswerCount = null
      this.saving = false
    },
    async resetAnswer() {
      this.saving = true
      const { projectid, propertyid } = this.$route.params
      if (!this.propertyIsSubmitted) {
        await this.deleteAnswer({ projectId: projectid, answerId: this.questionAnswer._id, propertyId: propertyid })
      } else {
        await this.addAnswerUpdate({ projectId: projectid, propertyId: propertyid, answer: { ...this.questionAnswer, value: '' } })
      }
      if (this.projectInReview) {
        await this.notifyOwnerOfAnswerChange()
      }
      if (this.question.required) {
        this.$root.$emit('refresh-required-categories')
      }
      if (this.isParticipant) {
        this.$root.$emit('bv::toggle::collapse', this.question._id)
      }
      this.answer.text = ''
      this.answer.number = null
      this.answer.choice = ''
      this.saving = false
    },
    async syncAnswer() {
      const { projectid, propertyid } = this.$route.params
      this.saving = true
      await this.syncPropertyAnswersWithLois({ projectId: projectid, propertyId: propertyid })
      await this.fetchAnswers({ projectId: projectid, propertyId: propertyid })
      if (this.question.required) {
        this.$root.$emit('refresh-required-categories')
      }
      this.saving = false
    }
  }
}
